export const wineryData = {
  'blending-lab': {
    id: 'blending-lab',
    name: 'The Blending Lab',
    logo: '/The Blending Lab/TBL Logo Black.png',
    photo: '/The Blending Lab/Michael Keller.jpeg',
    winemakerName: 'MICHAEL KELLER',
    title: 'Owner',
    website: 'THEWINEBLENDINGLAB.COM',
    websiteUrl: 'https://thewineblendinglab.com',
    bio: [
      "Michael Keller's passion for wine led him to found The Blending Lab Winery, a unique venture dedicated to educating wine drinkers through hands-on blending classes. The winery's mission is to demystify the art of wine blending through a foolproof process that makes wine appreciation accessible to everyone.",
      "The Blending Lab embraces the philosophy 'don't blame the wine!' This saying reflects their belief that understanding the nuances of grape varietals, growing regions, and vinification processes helps wine drinkers appreciate the differences and complexities in each bottle.",
      "Since 2014, The Blending Lab has been sourcing grapes from Paso Robles, one of California's premier wine regions. They invite wine enthusiasts to join them for classes, flights, and glasses at their tasting rooms in Los Angeles and Paso Robles, where visitors can experience the art of blending firsthand."
    ]
  },
  'alta-colina': {
    id: 'alta-colina',
    name: 'Alta Colina',
    logo: '/Alta Collina/AC_logoText.jpeg',
    photo: '/Alta Collina/AltaColina-00802 (1).jpg',
    winemakerName: 'DALLAS PARNIGONI',
    title: 'Winemaker',
    website: 'ALTACOLINA.COM',
    websiteUrl: 'https://altacolina.com',
    bio: [
      "Dallas Parnigoni's career in wine began in 2011, where, as high school-ers, he and his brother helped their father plant a Kentucky vineyard that would grow over the next decade and a half into one of the largest wineries in the state. After earning a bachelor's degree in food science from the University of Kentucky, Dallas moved to Paso Robles to complete his first harvest away from home.",
      "He has since worked in vineyards, labs and cellars in Tasmania, the Yarra Valley, Santa Cruz, and the Sierra Foothills before returning to San Luis Obispo to pursue a master's degree in Enology at Cal Poly. Prior to the 2025 harvest, Dallas joined Alta Colina as Winemaker, where the team's vineyard-first philosophy and low-intervention approach align closely with his own winemaking values."
    ]
  },
  'castoro': {
    id: 'castoro',
    name: 'Castoro Cellars',
    logo: '/Castoro/CC_LogoFull_CMYK-01.png',
    photo: '/Castoro/Craig Reed.jpg',
    winemakerName: 'CRAIG REED',
    title: 'Winemaker',
    website: 'CASTOROCELLARS.COM',
    websiteUrl: 'https://castorocellars.com',
    bio: [
      "Born and raised in the North County of San Luis Obispo, Craig was Winemaker at the former Martin and Weyrich (aka Martin Brothers) Winery for 22 years before spending his next 11 years running a small custom Winemaking facility here in Paso Robles.",
      "He joined the Castoro team for his 32nd Paso Robles harvest in 2020. Craig enjoys spending time with his wife, Angel, and son, Bennett, usually Snow Skiing or camping in the mountains or at the beach."
    ]
  },
  'grey-wolf': {
    id: 'grey-wolf',
    name: 'Grey Wolf',
    logo: '/Grey Wolf/GREY_LOGO-signature-black.jpg',
    photo: '/Grey Wolf/039.jpg',
    winemakerName: 'BRAD ELY',
    title: 'Winemaker',
    website: 'BARTONFAMILYWINES.COM',
    websiteUrl: 'https://bartonfamilywines.com',
    bio: [
      "Brad Ely's journey in winemaking has taken him across the globe, gaining experience in some of the world's most renowned wine regions. His international experience includes working in Washington, South Australia, New Zealand, and France, where he honed his craft and developed a deep understanding of different winemaking traditions and techniques.",
      "After his extensive international experience, Brad returned to California to continue his winemaking career. He now serves as Winemaker for Grey Wolf and Barton Family Wines, bringing his global perspective and expertise to the Paso Robles region.",
      "Beyond the cellar, Brad is passionate about winemaking and enjoys an active lifestyle. His hobbies include surfing, camping, and racing motorcycles, reflecting his adventurous spirit and connection to the California lifestyle."
    ]
  }
};
